import React, { useEffect, useState } from "react";
import { withRouter } from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ViewRow } from '../../../formElements';
import { connect } from 'react-redux';
import Img from '../../../../../img/sitedetail.png'
import { checkPermission } from '../../../../common/utils';

const SiteDetails = (propsobj) => {
  let isEditSite = checkPermission('Site_Details_Edit', 'Update');
  let [apiError, setApiError] = useState(false);
  let [progress, setProgress] = useState(false);

  const handleClick = async (event) => {
    event.preventDefault();
    propsobj.history.push('/account/studyDetails/site/update');
  }

  const { siteName = '', onboardStatus = '', limitization = '', impReceived = '' } = propsobj.formValues;

  return (
    <>
      {progress && <div className="fullScreen">
        <CircularProgress
          disableShrink
          className="progressCircle"
          value={90}
          size={100}
          thickness={1.5}
        />
      </div>}


      <div className="col-md-6 pl-0">
        <div className="d-flex">

          <div class="secondary-header mr-auto">Details</div>
          {
            isEditSite === "1" ? <div className="">
              <button onClick={handleClick} className="btn btn-small btn-primary-blue btn-shadow btn-rounded">
                <i className="fas fa-pencil-alt"></i>&nbsp; EDIT</button>
            </div> : ""
          }

        </div>
      </div>
      <div className="">
        <form noValidate autoComplete="off" id="addAccountForm" className="row h-form-1">
          <div className="col-md-6">
            <div className="panel-primary-wrap">
              <div className="card">
                <div className="card-body">

                  <div className="inputBox">
                    <ViewRow text="Site Name" textvalue={siteName} />
                    <ViewRow text="OnBoard Status" textvalue={onboardStatus} />
                    <ViewRow text="Limitization" textvalue={limitization} />
                    <ViewRow text="Imp Received" textvalue={impReceived} />

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6" style={{ textAlign:"center", alignItems: "center" }}>
            <img src={Img} alt="Image" />
          </div>
        </form>
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    formValues: state.form,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {}
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SiteDetails));



